<script lang="ts" setup>
  import { useRoute, useTranslator } from '@othercommerce/foundation';
  import { computed } from 'vue';
  import { BillingDriver } from '@othercommerce/domain';

  defineOptions({
    inheritAttrs: false,
  });

  interface Props {
    cart: { billingMethodDriver: { value: BillingDriver; label: string; } | null; },
    isCeneoEnabled: Boolean,
  }

  defineProps<Props>();

  const route = useRoute();
  const translator = useTranslator();

  const termsAndConditions = computed(() => {
    return translator.trans('SHOP.ORDER.LABEL.TERMS_AND_CONDITIONS', { url: route('web.termsAndCondition.index') });
  });

  const privacyPolicy = computed(() => {
    return translator.trans('SHOP.ORDER.LABEL.PRIVACY_POLICY', { url: route('web.privacyPolicy.index') });
  });

  const payuTerms = computed(() => {
    return translator.trans('SHOP.ORDER.LABEL.PAYU_TERMS');
  });

  const przelewy24Terms = computed(() => {
    return translator.trans('SHOP.ORDER.LABEL.PRZELEWY24_TERMS');
  });

  const tpayTerms = computed(() => {
    return translator.trans('SHOP.ORDER.LABEL.TPAY_TERMS');
  });

  const ceneoTerms = computed(() => {
    return translator.trans('SHOP.ORDER.LABEL.CENEO_TERMS');
  });

  const marketingTerms = computed(() => {
    return translator.trans('SHOP.ORDER.LABEL.MARKETING_TERMS');
  });
</script>
<template>
  <div class="conditions-form__item">
    <SfFormSwitch name="acceptanceTerms" required>
      <span v-html="termsAndConditions" />
    </SfFormSwitch>
  </div>
  <div class="conditions-form__item">
    <SfFormSwitch name="acceptanceRodo" required>
      <span v-html="privacyPolicy" />
    </SfFormSwitch>
  </div>
  <div v-if="cart.billingMethodDriver?.value === BillingDriver.PAYU" class="conditions-form__item">
    <SfFormSwitch name="acceptancePayu" required>
      <span v-html="payuTerms" />
    </SfFormSwitch>
  </div>
  <div v-if="cart.billingMethodDriver?.value === BillingDriver.PRZELEWY24" class="conditions-form__item">
    <SfFormSwitch name="acceptancePrzelewy24" required>
      <span v-html="przelewy24Terms" />
    </SfFormSwitch>
  </div>
  <div v-if="cart.billingMethodDriver?.value === BillingDriver.TPAY" class="conditions-form__item">
    <SfFormSwitch name="acceptanceTpay" required>
      <span v-html="tpayTerms" />
    </SfFormSwitch>
  </div>
  <div v-if="isCeneoEnabled" class="conditions-form__item">
    <SfFormSwitch name="acceptanceCeneo">
      <span v-html="ceneoTerms" />
    </SfFormSwitch>
  </div>
  <div class="conditions-form__item">
    <SfFormSwitch name="acceptanceMarketing">
      <span v-html="marketingTerms" />
    </SfFormSwitch>
  </div>
</template>
<style lang="scss" scoped>
  :root {
    --sf-sign-up-form-conditions-link-color-hover: var(--primary-color-hover);
  }

  .conditions-form {
    display: flex;
    flex-direction: column;
    gap: var(--form-gap-y) var(--form-gap-x);
  }

  :deep(.conditions-form__item-link) {
    text-decoration: underline;

  }
</style>
